//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
    props: ['uid'],
    async fetch() {
        const id = this.uid;
        this.search = this.$route.query.q;
        let filter = {};

        /* Get filters and pagination params based on query filters
         * @example host:varaosat/apple/iphone-8?currentPage=1
         *  */
        filter = this.createFilterObject(this.$route.query);

        const variables = { id, filter };
        if (this.$route.query.pageSize) {
            variables.pageSize = this.$route.query.pageSize;
        }
        if (this.$route.query.currentPage) {
            variables.currentPage = this.$route.query.currentPage;
        }
        if (this.$route.query.sortType && this.$route.query.sortDir) {
            const obj = {};
            obj[this.$route.query.sortType] = this.$route.query.sortDir;
            variables.sort = obj;
        }

        const {
            data: {
                products: { items, total_count, aggregations, page_info, sort_fields },
            },
        } = await this.$axios.$get(`/search/${this.search || ''}`, {
            params: variables,
        });

        this.products = items;
        this.category = {};
        this.total = total_count;
        // If there are no filters(like page initial load), or no last selected attribute found in store, apply all aggregations to filters
        if (!this.filters.length || !this.lastSelectedAttribute) {
            this.filters = aggregations;
        } else {
            const priceFilter = this.filters.find((filter) => filter.attribute_code === 'price');
            const newAggregations = aggregations.map((newFilter) => {
                if (newFilter.attribute_code === 'price' && filter['price']) {
                    return priceFilter;
                }
                return newFilter;
            });
            // If filters of last selected attribute are all disselected, apply all aggregations to filters
            if (!filter[this.lastSelectedAttribute]) {
                this.filters = newAggregations;
            } else {
                const filterNotTobeUpdated = this.filters.find((filter) => filter.attribute_code === this.lastSelectedAttribute);
                this.filters = newAggregations.map((newFilter) => {
                    if (newFilter.attribute_code === this.lastSelectedAttribute) {
                        return filterNotTobeUpdated;
                    }
                    return newFilter;
                });
            }
        }
        this.toolbar = page_info;
        this.sorts = sort_fields;

        const products = items;

        this.products = products;
    },
    data() {
        return {
            products: [],
            category: {},
            total: 0,
            filters: [],
            toolbar: {},
            filtersOpen: false,
            sorts: {},
            search: '',
            shownDisabledMessage: false,
        };
    },
    fetchKey: 'category-page',
    watch: {
        '$route.query'() {
            this.shownDisabledMessage = false;
            if (this.$route.name.includes('all') || this.$route.name.includes('search')) {
                this.$fetch();
            }
        },
    },
    async mounted() {
        if (this.products.length === 0 && this.$route.query.currentPage !== '1') {
            this.$fetch();
        }

        if (this.$gtm) {
            setTimeout(() => {
                try {
                    this.$gtm.push({ ecommerce: null, items: null });
                    this.$gtm.push({
                        event: 'view_item_list',
                        ecommerce: {
                            item_list_id: this.uid,
                            items: [...products].reduce((acc, curr) => {
                                acc.push({
                                    item_id: curr.sku,
                                    item_name: curr.name,
                                    price: curr.price_range.minimum_price.final_price.value,
                                });

                                return acc;
                            }, []),
                        },
                        items: [...products].reduce((acc, curr) => {
                            acc.push({
                                id: curr.sku,
                                google_business_vertical: 'retail',
                            });

                            return acc;
                        }, []),
                    });
                } catch (e) {
                    console.error(e);
                }
            }, 2000);
        }
    },
    computed: {
        ...mapGetters({
            lastSelectedAttribute: 'attributeFilter/getLastSelectedAttribute',
        }),
        enabledFilters() {
            const enabledFilters = this.createFilterObject(this.$route.query);
            const filtersCount = Object.keys(enabledFilters).length;

            if (filtersCount === 0) {
                return '';
            }

            return `(${filtersCount})`;
        },
    },
    methods: {
        createFilterObject(filters) {
            const sorts = ['pageSize', 'currentPage', 'sortType', 'sortDir', 'q'];

            return Object.entries(filters).reduce((result, [filterName, selected]) => {
                if (sorts.includes(filterName)) {
                    return {
                        ...result,
                    };
                }
                if (filterName === 'price' || filterName.includes('bucket') || filterName.to) {
                    let from, to;
                    if (Array.isArray(selected)) {
                        [from, to] = selected[0].split('_'); //eslint-disable-line
                    } else {
                        [from, to] = selected.split('_');
                    }
                    if (to === '*') to = '9999999999999';
                    let name = filterName;
                    if (filterName.includes('bucket')) {
                        name = filterName.replace('_bucket', '');
                    }

                    result[name] = {
                        to,
                        from,
                    };

                    return {
                        ...result,
                        [name]: {
                            to,
                            from,
                        },
                    };
                }

                return {
                    ...result,
                    [filterName]: {
                        in: selected,
                    },
                };
            }, {});
        },
        onPaginationUpdate(index) {
            const { query } = this.$route;
            delete query.currentPage;
            this.$scrollTo('#category-products');
            this.$router.push({ path: this.$route.path, query: { currentPage: index, ...query } });
        },
    },
    head() {
        return {
            title: `${this.search}`,
            titleTemplate: '%s',
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: `${this.$t('navigation.title')}: "${this.search}"`,
                },
            ],
        };
    },
};
